import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BaseMenuService, MenuItem } from '@fry/lib/menu';
import { AuthService } from '@fry/lib/auth';
import { SecurityService } from '@fry/lib/security';
import { TypeService } from './general.service';
import { catchError, map } from 'rxjs/operators';
import { SYSTEM_ROLE_ID } from '@fry/lib/roles/roles.system';


@Injectable()
export class GeneralMenu extends BaseMenuService {

    constructor(
      protected auth: AuthService,
      protected security: SecurityService,
      private types: TypeService,
    ) {
        super(auth, security);
        this.setup();
    }

    cook(): Observable<MenuItem[]> {
      const general = this.types.infos
        .filter(info => info.settings.showInSettings)
        .map(info => {
          return {
            id: `general-${info.type}`,
            link: `/general/${info.type}`,
            title: info.title,
            parent: 'settings'
          };
        });
      const routes = [
        {
          id: 'settings',
          title: $localize `Settings`
        },
        {
          id: 'organisation-settings',
          link: '/organisation',
          title: $localize `Organisation settings`,
          parent: 'settings'
        },
        ...general
      ];
      return this.security.hasRole(SYSTEM_ROLE_ID.ADMIN).pipe(
        map((has) => has ? routes : []),
        catchError(() => of([]))
      );
    }

    setup() {
      console.log(this.types);
    }
}
